<template>
  <div class="pa-4" :style="{padding:isMobile.isMobile?'0px 15px !important':''}">
    <v-card>
      <v-toolbar color="success"  v-if="!isMobile.isMobile">
        <span class="white--text text-subtitle-1">编译审核</span>
      </v-toolbar>
      <div class="pa-4">
        <v-data-table
          :headers="headers"
          :items="applyList"
          :sort-by="['currentSort', 'currentSortOrder']"
          :items-per-page="pagination.perPage"
          :page="pagination.currentPage"
          :sort-desc="[false, true]"
          multi-sort
          hide-default-footer
          no-data-text="暂无申请"
          class="paginated-table table-striped table-hover"
        >
          <!-- <template v-slot:top>
            <v-row justify="space-between">
              <v-col class="d-flex" cols="6" sm="2">
                <v-select
                  v-model="pagination.perPage"
                  class="compilePageSize"
                  :items="pagination.perPageOptions"
                  label="每页显示"
                ></v-select>
              </v-col>
              <v-col class="d-flex" cols="6" sm="2">
                <v-text-field
                  v-model="queryParams.name"
                  label="查找"
                  type="search"
                  class="mb-3 valueFilter"
                  clearable
                  style="width: 200px"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>-->
          <template #top>
            <v-toolbar flat height="80" class="toolbar">
              <v-text-field
                v-model="queryParams.name"
                append-icon="mdi-magnify"
                label="请输入名称"
                single-line
                hide-details
                @keydown="keydownSearch"
                class="valueFilter"
              ></v-text-field>
              <md-tooltip md-direction="top">按回车以检索</md-tooltip>
              <!-- <v-spacer></v-spacer>
                <v-btn
                  height="35"
                  :ripple="false"
                  small
                  elevation="0"
                  class="font-weight-normal text-capitalize btn-primary bg-gradient-success py-3 px-6 ms-3"
                  >新增</v-btn
              >-->
            </v-toolbar>
          </template>
          <template v-slot:item.apply_status="{ item }">
            {{
            item.apply_status | statusMap
            }}
          </template>
          <template v-slot:item.updated_at="{ item }">
            {{
            new Date(item.updated_at).toLocaleString()
            }}
          </template>

          <template v-slot:item.option="{ item }">
            <v-btn
              v-if="item.apply_status == 0"
              class="btnTaskEdit agreeWith"
              icon
              color="success"
              small
              @click.native="handleStatus(1, item)"
            >
              <span class="iconfont icon-tongyi iconStyle" ></span>
              <md-tooltip md-direction="top">同意</md-tooltip>
            </v-btn>

            <v-btn
              v-if="item.apply_status == 0"
              class="btnTaskEdit refuse"
              icon
              color="error"
              small
              @click.native="handleStatus(2, item)"
            >
              <span class="iconfont icon-jujue iconStyle"></span>
              <md-tooltip md-direction="top">拒绝</md-tooltip>
            </v-btn>

            <v-btn
              v-if="item.apply_status == 1"
              class="btnTaskEdit withdraw"
              icon
              color="gray"
              small
              @click.native="handleStatus(3, item)"
            >
              <span class="iconfont icon-chehui iconStyle"></span>
              <md-tooltip md-direction="top">撤回</md-tooltip>
            </v-btn>

            <v-btn
              v-if="item.apply_status == 3"
              class="btnTaskEdit republish"
              icon
              color="success"
              small
              @click.native="handleStatus(1, item)"
            >
              <span class="iconfont icon-zhongxinfasong iconStyle"></span>
              <md-tooltip md-direction="top">重新发布</md-tooltip>
            </v-btn>
          </template>
        </v-data-table>
      </div>

      <!-- <div class="d-flex justify-space-between align-center mt-4">
        <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
        <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
          :per-page="pagination.perPage" :total="pagination.total"> </pagination>
        <v-btn color="success" small >新增</v-btn>
      </div>-->

      <v-card-actions class="vCard-actions d-flex justify-space-between ma-3">
        <div class="md-layout md-gutter">
          <div
            class="md-layout-item md-xlarge-size-90 md-large-size-90 md-medium-size-80 md-small-size-80 md-xsmall-size-80"
          >
            <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
          </div>
          <!-- <div
            class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-20 md-small-size-20 md-xsmall-size-20"
          >
            <v-btn color="success" small>新增</v-btn>
          </div> -->
          <div
            class="md-layout-item md-xlarge-size-100 md-layout md-gutter md-alignment-center-center md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
          >
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></pagination>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import { listAduitSimulation as listSimulation, updateSimulation } from '@/api/simulation';
import { mapGetters } from 'vuex';
export default {
  name: 'applyComplie',
  filters: {
    statusMap(status) {
      const map = {
        0: '待审核',
        1: '已发布',
        2: '已拒绝',
        3: '已撤回',
      };
      return map[status];
    },
  },
  components: { Pagination },
  computed: {
    ...mapGetters(['isMobile']),
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return this.pagination.currentPage * this.pagination.perPage;
    },
    total() {
      return this.pagination.total;
    },
  },
  watch: {
    from() {
      this.getList();
    },
    'queryParams.name'() {
      this.getList();
    },
  },
  data: () => ({
    selectedItem: 1,
    applyList: [],
    headers: [
      { text: '项目名称', align: 'center', value: 'name' },
      { text: '版本号', align: 'center', value: 'version' },
      { text: '平台类型', align: 'center', value: 'platform' },
      { text: '审核状态', align: 'center', value: 'apply_status' },
      { text: '审核时间', align: 'center', value: 'updated_at' },
      { text: '编辑', align: 'center', value: 'option', width: '100px' },
    ],
    currentSort: 'name',
    currentSortOrder: 'asc',
    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 15, 25],
      total: 0,
    },
    queryParams: {},
    taskModeMap: {
      study: '学习',
      train: '练习',
      exam: '考核',
    },
  }),
  mounted() {
    this.getList();
  },
  methods: {
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.currentPage = 1;
        this.getList();
      }
    },
    getList() {
      const queryParams = Object.assign(
        {},
        {
          ...this.pagination,
          ...this.queryParams,
        }
      );
      listSimulation(queryParams).then(res => {
        this.applyList = res.data.rows;
        this.pagination.total = res.data.total;
      });
    },
    async handleStatus(status, item) {
      const map = {
        1: '发布',
        2: '拒绝',
        3: '撤回',
      };
      let result = await Swal.fire({
        title: '提示',
        text: `确认${map[status]} 《${item.name}》？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        const data = Object.assign(item, { apply_status: status });
        updateSimulation(data).then(res => {
          this.$store.dispatch('global/showSuccessMsg', '操作成功');
          this.getList();
        });
      }
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('task/removeTask', item);
      }
    },
  },
};
</script>

<style scoped>
.white--text {
  margin-left: 25px;
}

.pa-4 {
  padding-top: 0px !important;
}

.toolbar {
  margin-top: 7px;
  padding: 0;
}

/deep/ .toolbar .v-toolbar__content {
  padding: 0px;
}
.iconStyle{
  font-size: 20px;
}
</style>
